import * as React from 'react';
import { useMemo } from 'react';
import cn from 'classnames';

import { AviaFareFamilyOption, FareFeaturePaymentType } from '@websky/graphql';
import { useTheme } from '../../../../../theme';

import { CdnIcon, CdnIconNames, SafeHtml } from '@shared/ui';

const ICON_NAME_BY_PAYMENT_TYPE: Record<FareFeaturePaymentType, CdnIconNames> = {
	[FareFeaturePaymentType.Free]: 'Info/Item Icluded',
	[FareFeaturePaymentType.Pay]: 'Info/Item Paid',
	[FareFeaturePaymentType.NotAvailable]: 'Info/Not included'
};

export interface Props {
	cell: AviaFareFamilyOption;
	customAvailabilityIcons?: Record<FareFeaturePaymentType, React.ReactNode>;
	isFullFareCondition: boolean;
}

const Cell: React.FunctionComponent<Props> = ({ cell, isFullFareCondition, customAvailabilityIcons }) => {
	const { Cell: css, Content: contentCss } = useTheme('CompareFares');

	if (!cell) {
		return (
			<div
				className={cn(css.cell, {
					[css.cell_notFullFareConditions]: !isFullFareCondition
				})}
			>
				<div className={css.cellContent}>{''}</div>
			</div>
		);
	}

	const { description, availability } = cell;

	const icon = useMemo(() => {
		if (customAvailabilityIcons?.[availability]) {
			return customAvailabilityIcons[availability];
		}

		return <CdnIcon icon={ICON_NAME_BY_PAYMENT_TYPE[availability]} />;
	}, [customAvailabilityIcons, availability]);

	return (
		<div
			className={cn(css.cell, {
				[css.cell_notFullFareConditions]: !isFullFareCondition
			})}
		>
			{isFullFareCondition && (
				<div className={contentCss.col}>
					<SafeHtml tag="div" className={cn(css.cellContent, css.cellContent_fullDescr)} html={description} />
				</div>
			)}
			{!isFullFareCondition && (
				<div className={css.cellContent}>
					<div
						className={cn(css.availabilityIcon, {
							[css.availabilityIcon_paid]: availability === FareFeaturePaymentType.Pay,
							[css.availabilityIcon_included]: availability === FareFeaturePaymentType.Free,
							[css.availabilityIcon_notAvailable]: availability === FareFeaturePaymentType.NotAvailable
						})}
					>
						{icon}
					</div>
				</div>
			)}
		</div>
	);
};

export default Cell;
